import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Button, Spinner, Typography } from 'seagull';
import ContactSupportButton from '~/components/ContactSupportButton';
import { useStoreStatic } from '~/contexts';
import { useSetAuthToken } from '~/hooks/useSetAuthToken';
import { useStoreActions } from '~/store/store-context';
import { BusinessPartyTypeEnum } from '~/store/store.model';
import { SavingState } from './SavingStep';
import styles from './SavingStep.module.scss';
export function SavingFirstStep(props) {
    const { vobData, onSuccess, onError } = props;
    const { api, fetchUserInfo, updateUserClientData } = useStoreActions();
    const { getState } = useStoreStatic();
    const setAuthToken = useSetAuthToken();
    const [savingState, setSavingState] = useState(SavingState.Saving);
    useEffect(()=>{
        saveFirstStepData().then(()=>fetchUserInfo()).then(()=>onSuccess()).catch(()=>setSavingState(SavingState.Error));
    }, []);
    async function saveFirstStepData() {
        await api.auth.editUserDetails({
            name: vobData.name
        });
        const userInfo = getState().userInfo;
        const existingVendor = userInfo === null || userInfo === void 0 ? void 0 : userInfo.business();
        const hasExistingVendorToUpdate = (existingVendor === null || existingVendor === void 0 ? void 0 : existingVendor.type) === BusinessPartyTypeEnum.Vendor;
        if (hasExistingVendorToUpdate) {
            var _existingPa_addressTwo;
            const existingPa = existingVendor === null || existingVendor === void 0 ? void 0 : existingVendor.postalAddress;
            await api.vendor.update({
                name: vobData.companyName,
                description: vobData.businessDescription || '',
                postalAddress: existingPa ? {
                    address1: existingPa.addressOne,
                    address2: (_existingPa_addressTwo = existingPa.addressTwo) !== null && _existingPa_addressTwo !== void 0 ? _existingPa_addressTwo : '',
                    city: existingPa.city,
                    state: existingPa.state,
                    postalCode: existingPa.postalCode,
                    country: existingPa.country
                } : undefined
            });
        } else {
            const { authToken } = await api.vendor.create({
                name: vobData.companyName,
                description: vobData.businessDescription || ''
            });
            if (authToken != null) {
                await setAuthToken(authToken);
            }
        }
        const numOfInvoices = parseInt(vobData.numOfInvoices);
        if (!isNaN(numOfInvoices)) {
            await updateUserClientData({
                'onboarding-num-clients': numOfInvoices
            });
        }
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            savingState === SavingState.Saving ? /*#__PURE__*/ _jsxs("div", {
                className: styles.savingContainer,
                "data-testid": "vob-saving-first-step",
                children: [
                    /*#__PURE__*/ _jsx(Spinner, {}),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: "Setting up your account"
                    })
                ]
            }) : null,
            savingState === SavingState.Error ? /*#__PURE__*/ _jsxs("div", {
                className: styles.errorContainer,
                "data-testid": "vob-error",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.content,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: "vob-failure-reason",
                                variant: "h4",
                                children: "Something unexpected happened"
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                skin: "secondary",
                                children: [
                                    "Click",
                                    ' ',
                                    /*#__PURE__*/ _jsx(Typography, {
                                        as: "span",
                                        weight: "bold",
                                        children: "Back"
                                    }),
                                    ' ',
                                    "to try again or ",
                                    /*#__PURE__*/ _jsx(ContactSupportButton, {
                                        bi: {
                                            name: 'contact_support'
                                        }
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.footer,
                        onClick: onError,
                        children: /*#__PURE__*/ _jsx(Button, {
                            testId: "vob-error-back-btn",
                            bi: {
                                name: 'error_back'
                            },
                            children: "Back"
                        })
                    })
                ]
            }) : null
        ]
    });
}
